import React from 'react'
import {MinimalHotelCard} from 'components/MinimalHotelCard'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Bookings} from '@vio/core/src/api-types/bovio/response/bookings'
import {roomsToString} from '@vio/core/src/room/business/roomConfiguration'
import {useGetHotelQuery} from '@vio/core/src/sapi/services/searchApi'

export const Booking = ({
  hotelId,
  checkIn,
  checkOut,
  rooms,
  fullWidth,
  onClick
}: Pick<Bookings, 'hotelId' | 'checkIn' | 'checkOut' | 'rooms'> & {
  fullWidth: boolean
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const {
    data: hotel,
    isSuccess,
    isFetching,
    isError,
    isLoading
  } = useGetHotelQuery({hotelId})

  const roomsString = roomsToString(rooms)

  if (isError) return null

  if (!isSuccess || isFetching || isLoading)
    return (
      <Box display="flex" alignItems="center" gap="s400" width="227px">
        <Box width="56px" height="88px">
          <SkeletonLoader height="100%" />
        </Box>
        <Box flex="1">
          <SkeletonLoader width={120} />
          <SkeletonLoader width={80} />
        </Box>
      </Box>
    )

  return (
    <MinimalHotelCard
      fullWidth={fullWidth}
      onClick={onClick}
      title={hotel.hotelName}
      checkIn={checkIn}
      checkOut={checkOut}
      imageUrl={hotel.imageURIs[0]}
      rooms={roomsString}
    />
  )
}
